import * as React from 'react';

const HappyFaceFilled16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.995 1.548a6.452 6.452 0 1 0 0 12.904 6.452 6.452 0 0 0 0-12.904M-.005 8a8 8 0 1 1 16 0 8 8 0 0 1-16 0"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.93 5.935a1.032 1.032 0 1 1-2.064 0 1.032 1.032 0 0 1 2.065 0Zm6.194 0a1.032 1.032 0 1 1-2.064 0 1.032 1.032 0 0 1 2.064 0m-4.13 5.936c1.868 0 3.018-.681 3.509-1.072.913-.727-.019-2.028-.995-1.251-.263.209-1.036.725-2.514.725s-2.25-.516-2.513-.725c-.988-.787-1.935.502-.995 1.25.491.392 1.64 1.073 3.508 1.073"
  }
));
HappyFaceFilled16.Size = 16;
HappyFaceFilled16.Title = "HappyFaceFilled";

export { HappyFaceFilled16 as default };
